import { TrayIcon } from "../../../../../../v1/components/atoms/Icons";

export const LoadingTasks = () => (
  <div className="loading-tasks">
    <TrayIcon />
  </div>
);
